import React from "react";
import styled, { css } from "styled-components";
import {
  Row as FlexboxRow,
  Col as FlexboxCol,
  RowProps as FlexboxRowProps,
  ColProps as FlexboxColProps,
} from "react-flexbox-grid/dist/react-flexbox-grid";

export interface RowProps extends FlexboxRowProps {
  centered?: boolean;
}
export const Row = styled(({ centered, ...props }) => (
  <FlexboxRow {...props} />
))<RowProps>`
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  max-width: ${({ theme }) => theme.media.breakpoint.largeX}px;
  padding-left: 40px;
  padding-right: 40px;
  @media only screen and (max-width: ${({ theme }) =>
      theme.media.maxWidth.largeX}px) {
    max-width: ${({ theme }) => theme.media.breakpoint.large}px;
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.media.maxWidth.large}px) {
    max-width: ${({ theme }) => theme.media.breakpoint.mediumX}px;
    padding-left: 20px;
    padding-right: 20px;
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.media.maxWidth.mediumX}px) {
    max-width: ${({ theme }) => theme.media.breakpoint.small}px;
  }
  ${({ centered }) =>
    centered &&
    css`
      margin-left: auto;
      margin-right: auto;
    `};
`;

export interface ColProps extends FlexboxColProps {}
export const Col = styled(FlexboxCol)<ColProps>``;
